var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boards_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12343",
    transform: "translate(17556 12054)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17511.6-12020.3h-17.5c-1.1,0-1.9-0.9-1.9-1.9v-29.2c0-1.1,0.9-1.9,1.9-1.9h17.5c1.1,0,1.9,0.9,1.9,1.9 v29.2C-17509.6-12021.2-17510.5-12020.3-17511.6-12020.3z M-17527.2-12024.2h13.6v-25.3h-13.6V-12024.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17517.4-12040.7h-5.8c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 C-17515.5-12041.6-17516.3-12040.7-17517.4-12040.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17517.4-12032.9h-5.8c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 S-17516.3-12032.9-17517.4-12032.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12344",
    transform: "translate(17556 12054)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17536.9-12008.6h-17.5c-1.1,0-1.9-0.9-1.9-1.9v-40.9c0-1.1,0.9-1.9,1.9-1.9h17.5c1.1,0,1.9,0.9,1.9,1.9 v40.9C-17534.9-12009.5-17535.8-12008.6-17536.9-12008.6z M-17552.5-12012.5h13.6v-37h-13.6V-12012.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17542.7-12040.7h-5.8c-1.1,0-1.9-0.9-1.9-1.9c0-1.1,0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 C-17540.8-12041.6-17541.7-12040.7-17542.7-12040.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17542.7-12032.9h-5.8c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 S-17541.7-12032.9-17542.7-12032.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-17542.7-12025.2h-5.8c-1.1,0-1.9-0.9-1.9-1.9s0.9-1.9,1.9-1.9h5.8c1.1,0,1.9,0.9,1.9,1.9 S-17541.7-12025.2-17542.7-12025.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoards);
export default __webpack_public_path__ + "static/media/Boards.bb01c37c3247daddd3cf5df7130b2b97.svg";
export { ForwardRef as ReactComponent };